<template>
  <section id="feature-hero">
    <BackgroundImage
      :background="data.heroImage"
      :preload="true"
      :_type="'imageBackground'"
      background-size="full-page"
      light-text
      :class="{
        'bg-top pb-100px pt-[165px]': true,
      }"
    >
      <div
        :class="{
          'mx-auto grid w-320px gap-4 text-center text-www-color-white md:w-[612px] lg:w-[928px] xl:w-[1120px]': true,
        }"
      >
        <h1
          :class="{
            'text-28px font-black leading-8 lg:text-42px lg:leading-[4.3125rem] xl:text-60px': true,
          }"
        >
          {{ data.title }}
        </h1>

        <h2
          :class="{
            'text-6 text-[1.625rem] font-medium leading-9': true,
          }"
        >
          <PortableText
            v-if="data.subtitle.homePagePortableText"
            :portable-data="data.subtitle.homePagePortableText"
          />
        </h2>
      </div>
    </BackgroundImage>
  </section>
</template>

<script lang="ts" setup>
import BackgroundImage from '~/components/Atoms/BackgroundImage/BackgroundImage.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import type { QueryFeatureResult } from '~/sanity/types';

interface Props {
  data: Pick<NonNullable<QueryFeatureResult>, 'title' | 'subtitle' | 'heroImage'>;
}

defineProps<Props>();
</script>

<style>
#feature-hero h4 {
  @apply !text-[1.625rem] !font-medium;
}
</style>
